// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"styles_cardsContainer__9wppy","teamCardSkeleton":"styles_teamCardSkeleton__2vb5H","header":"styles_header__2fuZ_","content":"styles_content__123Uh"};